define(function (require) {
    var avalon = require('avalon'),
        tool = require('toolLoaderPC'),
        hiddenValues = null;

    avalon.define({
        $id: 'errorController'
    });

    return {
        init: function () {
            hiddenValues = tool.getHiddenValues('#js-local-hiddens');

            var isSucceed = hiddenValues['is_pay_succeed'];
            if (isSucceed == 1) {
                tool.sendEventTracking('pc', '11400');
            }
        },
        clear: function () {}
    };
});



// WEBPACK FOOTER //
// ./src/js_modules/errorController.js